export default {
  labels: {
    invoice: 'Facture',
    on_site: 'Payer sur place (Espèces/Carte)',
  },
};
